import { useQuery } from "react-query";
import { parseISO } from "date-fns";

import { fetchClient } from "../../shared/api/fetching";
import { mlsGetMatches } from "../../shared/api/variables";
import { useReactAppState } from "../../shared/containers/utils";
import { formatStatsAPIMatches } from "../../mls-horizontal-scoreboard/utils";
import { dateRangeTypes, filterMlsMatchesByCompetitionsToSkip, isAllOptionSelected } from "../utils";

function useMLSMatches({
  isoStringRS,
  isoStringRE,
  clubSportecId,
  competitionSportecId,
  forceWeekly,
  firstForce,
  refetchInterval,
  currentDatePoint,
  dateRangeType,
  seasonSportecId,
}) {
  const { apiList } = useReactAppState();

  const mlsMatchesEndpoint = mlsGetMatches({
    seasonSportecId,
    from: isoStringRS, to: isoStringRE,
    competitionSportecId: isAllOptionSelected(competitionSportecId) ? null : competitionSportecId,
    clubSportecId: isAllOptionSelected(clubSportecId) ? null : clubSportecId,
    sort: "planned_kickoff_time:asc,home_team_name:asc"
  });

  return useQuery({
    queryKey: ["mls-matches-date-range", {
      isoStringRS,
      isoStringRE,
      clubSportecId,
      competitionSportecId,
    }],
    queryFn: () => fetchClient({ endpoint: mlsMatchesEndpoint, apiURL: apiList?.statsAPI }),
    refetchInterval: refetchInterval ? refetchInterval : null,
    enabled: !!(currentDatePoint) && !!(mlsMatchesEndpoint) && forceWeekly && firstForce ? dateRangeType == dateRangeTypes.week : !!(mlsMatchesEndpoint),
    refetchOnWindowFocus: false,
    retry: 2,
    select: response => {
      if (response?.schedule) {
        const sortedMatches = [...response?.schedule?.sort((a, b) => parseISO(a.planned_kickoff_time) - parseISO(b.planned_kickoff_time))];

        return formatStatsAPIMatches(filterMlsMatchesByCompetitionsToSkip(sortedMatches));
      }

      return [];
    },
    enabled: !!(seasonSportecId && competitionSportecId)
  });
}

export default useMLSMatches;